import { Injectable } from '@angular/core';
import { TranslateRoleUseCase } from '../application/use-cases/translate-role.use-case';

/**
 * Presentation Layer Service
 * Servicio de presentación que utiliza Clean Architecture
 * Sin hardcoding - todas las traducciones vienen de configuración externa
 */
@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor(private translateRoleUseCase: TranslateRoleUseCase) {}

  /**
   * Traduce los nombres de roles al español (método síncrono para compatibilidad)
   * NOTA: Este método mantiene compatibilidad pero debería migrarse a translateRoleAsync
   * @deprecated Usar translateRoleAsync en su lugar
   */
  getRoleNameInSpanish(roleName: string): string {
    // Retorna el nombre original si no hay traducción disponible
    // Esto evita hardcoding y fuerza el uso de configuración externa
    return roleName;
  }

  /**
   * Traduce un array de roles al español (método síncrono para compatibilidad)
   * NOTA: Este método mantiene compatibilidad pero debería migrarse a translateRolesAsync
   * @deprecated Usar translateRolesAsync en su lugar
   */
  translateRoles(roles: any[]): any[] {
    // Retorna los roles sin traducir para evitar hardcoding
    // Esto fuerza el uso de los métodos asíncronos que usan configuración externa
    return roles;
  }

  /**
   * Traduce un rol usando Clean Architecture (método asíncrono)
   * Este es el método recomendado que usa configuración externa
   */
  async translateRoleAsync(roleName: string, language: string = 'es'): Promise<string> {
    return await this.translateRoleUseCase.execute(roleName, language);
  }

  /**
   * Traduce múltiples roles usando Clean Architecture (método asíncrono)
   * Este es el método recomendado que usa configuración externa
   */
  async translateRolesAsync(roles: any[], language: string = 'es'): Promise<any[]> {
    return await this.translateRoleUseCase.translateRoles(roles, language);
  }
}
